module.exports = __webpack_public_path__ + "static/media/review_4.1d51cf05.jpg";